<template>
    <section>
        <transition-group name="modal">
            <div id="brand" class="modal-mask" key="brand">
                <!-- <img src="../../assets/croix.png" width="20" height="20" alt="" class="cross fright abs pointer" -->
                <!-- @click="closeModal()"> -->
                <div class="modal-wrapper _modalWrapper_">
                    <div class="modal-container flexContainer">
                        <div class="modalBody">
                            <div class="modalContent">
                                <loader :loading="loading"></loader>
                                <h1 class="uppercase title center txtCenter">{{ $t("standDesign.edit") }}</h1>
                                <table>
                                    <tr>
                                        <td>
                                            <label class="uppercase labelStand">{{ $t("standDesign.name") }}</label>
                                        </td>
                                        <td><input type="text" class="input inputSD" v-model="standDesign.name" /></td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label class="uppercase labelStand">{{ $t("standDesign.description") }}</label>
                                        </td>
                                        <td><textarea type="text" class="input inputSDDdes" v-model="standDesign.description"></textarea></td>
                                    </tr>
                                </table>

                                <div class="flexContainer boutonSaveDelete">
                                    <button class="btn block pointer save uppercase" :disabled="!canSave" @click="saveStand();">
                                        {{ $t("standDesign.save") }}
                                    </button>
                                    <button class="btn block pointer uppercase save" @click="closeModal();">{{ $t("common.cancel") }}</button>
                                    <button class="btn block pointer uppercase" @click="deleteStand();">{{ $t("standDesign.delete") }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition-group>
    </section>
</template>

<script>
import httpService from "../service";
import { mapGetters } from "vuex";
import { i18n } from "../../main.js";
import loader from "@/components/loader/loader";

export default {
    components: { loader },
    data: () => ({
        standDesign: {},
        standTypeList: [],
        loading: false
    }),
    created() {
        this.standDesign = { ...this.getStandDesign };
    },
    methods: {
        closeModal() {
            this.$emit("editStandDesign");
        },
        async saveStand() {
            if (this.disabled) return;
            this.loading = true;
            let stand = {
                name: this.standDesign.name,
                description: this.standDesign.description,
                brand: {
                    id: this.standDesign.brand.id
                }
            };
            try {
                const res = await httpService.put("/admin/standDesigns/" + this.standDesign.id, JSON.stringify(stand));
                if (res.code) throw res.message;
                location.reload();
            } catch (e) {
                this.dialogError(e);
            } finally {
                this.loading = false;
            }
        },
        deleteStand() {
            let self = this;
            let confirmTitle;
            let warningText;
            if (i18n.locale === "fr") {
                confirmTitle = "ERROR";
                warningText = "Ce stand design ne peut être supprimé car elle est utilisée en référence par des ccomposants et/ou planogrammes!";
            } else if (i18n.locale === "en") {
                confirmTitle = "ERROR";
                warningText = "This stand design cannot be deleted because it's being used by some components/planograms";
            }
            httpService.get("/admin/standDesigns/" + this.standDesign.id + "/used").then(function(response) {
                if (response.length === 0) {
                    httpService.delete("/admin/standDesigns/" + self.standDesign.id).then(function(response) {
                        self.$swal({
                            html: "SUCCESS",
                            type: "success",
                            showCancelButton: false,
                            confirmButtonColor: "green",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: "OK"
                        }).then(result => {
                            location.reload();
                        });
                    });
                } else {
                    self.$swal({
                        html: confirmTitle + "<br />" + warningText,
                        type: "warning",
                        showCancelButton: false,
                        confirmButtonColor: "red",
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        confirmButtonText: "OK"
                    }).then(result => {
                        location.reload();
                    });
                }
            });
        }
    },
    computed: {
        ...mapGetters({
            getStandDesign: "items/getStandDesign"
        }),
        canSave() {
            return this.standDesign.name && this.standDesign.description;
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/themes.scss";

.boutonSaveDelete {
    margin-left: 347px;
    .save {
        margin-right: 12px;
    }
}

.title {
    font-family: "Oswald", Sans-Serif;
}
/* height firefox modal */
._modalWrapper_ {
    height: auto;
}

/* end height */
.modal-mask {
    position: fixed;
    z-index: 400;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
    .cross {
        top: 77px;
        right: 300px;
        z-index: 2;
    }
}

.labelStand {
    margin-top: 2px;
    font-family: Roboto;
    font-weight: bold;
    font-size: 1.17em;
    padding-left: 20px;
    padding-right: 10px;
}

.inputSD {
    font-size: 16px;
    border: none;
    border-bottom: 1px solid #333333;
    @extend %second-border-color;
    @extend %primary-text;
}
.inputSDDdes {
    font-size: 16px;
    width: 100%;
    @extend %second-border-color;
    @extend %primary-text;
}
.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
    .modal-container {
        width: 100%;
        height: 100%;
        margin: 0px auto;
        padding: 20px 30px;

        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        font-family: Helvetica, Arial, sans-serif;
        position: relative;
        .logoContainer {
            width: 880px;
            .brandLogo {
                border-radius: 0.7rem;
                height: 110px;
                background-color: white;
                width: 100%;
                img {
                    margin: auto;
                }
            }
        }
        .modalBody {
            @extend %second-bloc;
            @extend %primary-text;
            width: 900px;
            height: auto;
            border-radius: 4px;
            padding: 15px;
            margin: auto;
            .modalContent {
                h2 {
                    font-size: 1.6rem;
                }
                p {
                    font-size: 1.4rem;
                    margin: 30px 0;
                }
                #favoriteName {
                    background-color: transparent;
                    border: none;
                    border-bottom: 1px solid #343434;
                    margin-bottom: 30px;
                    font-family: Roboto;
                    font-size: 14px;
                    &:focus {
                        outline: none;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// EditStandDesign.vue?38cc717f